import WysiwygEditor from '../WysiwygEditor';

interface EditorPaneProps {
  markdown: string;
  onMarkdownChange: (markdown: string) => void;
  editable: boolean;
  showToolbar?: boolean;
}

/**
 * EditorPane - A wrapper component for the WYSIWYG editor
 * Provides a clean interface for editing markdown/HTML content
 * @param markdown.markdown
 * @param markdown - The markdown content to edit
 * @param onMarkdownChange - Callback when content changes
 * @param editable - Whether the editor is editable
 * @param showToolbar - Whether to show the toolbar
 * @param markdown.onMarkdownChange
 * @param markdown.editable
 * @param markdown.showToolbar
 */
export const EditorPane = ({ markdown, onMarkdownChange, editable, showToolbar }: EditorPaneProps) => {
  return (
    <div className="editor-pane">
      <WysiwygEditor content={markdown} onChange={onMarkdownChange} editable={editable} showToolbar={showToolbar} />
    </div>
  );
};
